export enum RepositFilter {
  ACTIVE = 'ACTIVE',
  EXPIRED = 'EXPIRED',
}

export const REPOSIT_PAYMENT_WARNING = `If I am not a named cardholder on the card used to make payment, I
hereby represent and warrant that I have the express authority of the cardholder to make this payment and enter into these
obligations on their behalf.`;
